import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App/app';
import * as serviceWorker from './serviceWorker';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import store from '../src/redux/configureStore';
import { history } from '../src/redux/history';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Auth } from './aws-exports';
import Amplify from 'aws-amplify';
import AWS from 'aws-sdk';
AWS.config.region = Auth.AWS_REGION;
const theme = createMuiTheme({
  palette: {
    primary: { main: '#0073a8' },
    secondary: { main: '#404040' },
    error: { main: '#DC1500' },
    contrastText: '#fff',
  },
  action: {
    disabledBackground: '#666666',
    disabled: '#404040',
  },
  button: {
    borderRadius: 28,
    paddingRight: 15,
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: 28,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 28,
        paddingTop: 15,
        paddingBottom: 15,
      },
    },
  },
  typography: {
    h1: {
      fontFamily: 'Helvetica',
      fontSize: 38,
      fontStyle: 'normal',
    },
    h2: {
      fontFamily: 'Helvetica',
      fontStyle: 'normal',
    },
    h3: {
      fontFamily: 'Helvetica',
      fontStyle: 'normal',
    },
    h4: {
      fontFamily: 'Helvetica',
      fontStyle: 'normal',
      fontSize: 28,
    },
    h5: {
      fontFamily: 'Helvetica',
    },
    h6: {
      fontFamily: 'Helvetica',
    },
    subtitle1: {
      fontFamily: 'Arial',
      fontSize: 12,
    },
    body1: {
      fontWeight: 500,
      fontFamily: 'Arial',
      color: '#606060',
    },
  },
});
Amplify.configure({ Auth });

render(App);
if (process.env.NODE_ENV !== "development"){
    console.log = () => {};
 }

if (module.hot) {
  module.hot.accept('./components/App/app', () => {
    let nextApp = require('./components/App/app').default;
    render(nextApp);
  });
}

function render(appComponent) {
  ReactDOM.render(
    <MuiThemeProvider theme={theme}>
      <AppContainer>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Switch>
              <Route component={appComponent} path="/" />
            </Switch>
          </ConnectedRouter>
        </Provider>
      </AppContainer>
    </MuiThemeProvider>,
    document.getElementById('root'),
  );
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
